import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { PayrollFederalEarningsSetup } from "../../components/PayrollFederalEarningsSetup/PayrollFederalEarningsSetup";
import { PayrollHolidayEarningsSetup } from "../../components/PayrollHolidayEarningsSetup";
import { PayrollInsurableEarningsSetup } from "../../components/PayrollInsurableEarningsSetup";
import { PayrollPensionableEarningsSetup } from "../../components/PayrollPensionableEarningsSetup/PayrollPensionableEarningsSetup";

export const PayrollHolidayEarningsSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Payroll Holiday Earnings Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        // { text: "Company", navigateTo: "/company/payrollFederalEarnings/list" },
        { text: "Payroll Holiday Earnings", navigateTo: "/company/payrollHolidayEarnings/setup" }
      ]}
      mainContents={<PayrollHolidayEarningsSetup />}
    />
  );
};
